import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { Button, Card, Checkbox, Form, notification, Tabs, Select } from "antd";
import _ from "lodash";

import { hideLoader, showLoader } from "../../../../modules/actions";
import Request, { API_URL, LAPI_URL, MEDIA_URL } from "../../../../request";
import { connect } from "react-redux";
const Option = Select.Option

const TabPane = Tabs.TabPane;
// following variables needed for update country
let docLoaded = null;
let branchId = null;

@Form.create()
class AddSubAgent extends PureComponent {
  callback = (key) => {
    let inputTypes = this.state.inputTypes;

    if (branchId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
      inputTypes[key - 1].opened = true;
      if (docLoaded.paymentUpload) {
        docLoaded.paymentUpload = _.map(docLoaded.paymentUpload, (item) => {
          let ind = item.url.indexOf('http')
          item.url = ind >= 0 ? `${item.url}` : `${MEDIA_URL}${item.url}`
          return item
        })
      }

      let tempObj = {};
      _.each(inputTypes[key - 1].fields, (v, k) => {
        tempObj[v.key] = docLoaded[v.key];
      });


      setTimeout(() => {
        this.props.form.setFieldsValue(tempObj);
      }, 10);
    }
  };

  handleSubmit = (e) => {
    const { dispatch, form, afterSave } = this.props;
    const { isStateHead, branchIds, associatePartnerIds, showChannelPartner, showStaffToOtherBranch } = this.state;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);
        values.isStateHead = isStateHead;
        values.showChannelPartner = showChannelPartner;
        values.showStaffToOtherBranch = showStaffToOtherBranch;
        values.branchIds = branchIds;
        values.associatePartnerIds = associatePartnerIds;
        values.branchAssociatePartner = "Associate Partner"
        if (branchId) {
          values = { ...values, _id: branchId };

          dispatch(showLoader());
          let x = await Request.updateSubAgent(values)

          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: 'Agent updated Successfully',
            });
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        } else {
          dispatch(showLoader());

          let x = await Request.addSubAgent(values);
          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: 'Agent updated Successfully',
            });

            if (afterSave) {
              afterSave();
            }
            form.resetFields();
            this.setState({ isStateHead: false, showChannelPartner: false, showStaffToOtherBranch: false });
            // dispatch('/all-countries')
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        }
      }
    });
  };
  getAgentTypePlans = async (agentType = "Associate Partner") => {
    Request.getAgentTypePlans(agentType)
      .then((daa) => {
        const result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.planName,
          });
          return total;
        }, []);

        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][20].options = result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => { });
  }
  constructor(props) {
    super(props);
    this.state = {
      showSave: 1,
      showFiles: 0,
      refreshChild: false,
      branchAssociatePartnerType: null,
      branchIds: [],
      associatePartnerIds: [],
      branchs: [],
      phoneCodes: [],
      inputTypes: [
        {
          tabTitle: "Basic Details",
          fields: [
            {
              label: "Agent Name",
              key: "branchName",
              required: true,
            },
            {
              label: "Address",
              key: "branchAddress",
              type: "textArea",
              rows: 10,
              required: true,
            },
            {
              label: "Select Country ",
              key: "branchCountryId",
              required: true,
              type: "select",
              showSearch: true,
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  branchCountryId: v,
                  branchStateId: null,
                  branchCityId: null,
                });
                this.loadStates(v);
              },
            },
            {
              label: "Select State",
              key: "branchStateId",
              required: true,
              type: "select",
              showSearch: true,
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  branchStateId: v,
                  branchCityId: null,
                });
                this.loadCities(v);
              },
            },
            {
              label: "Select City",
              key: "branchCityId",
              required: true,
              showSearch: true,
              type: "select",
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  branchCityId: v,
                });
              },
            },
            { label: "Agent Landline Phone One  ", key: "branchPhone1" },
            { label: "Agent Landline Phone Two ", key: "branchPhone2" },
            {
              label: "Name",
              key: "branchHeadName",
              prefixComp: <h3>Sub Agent Head</h3>,
            },
            { label: 'Country Code', key: 'branchHeadPhoneCode', type: 'select', options: [], showSearch: true, onChange: v => this.props.form.setFieldsValue({ branchHeadPhoneCode: v }) },
            { label: "Phone", key: "branchHeadPhone" },
            { label: "Email", key: "branchHeadEmail" },

            {
              label: "Name",
              key: "branchManagerName",
              prefixComp: <h3>Sub Agent Manager</h3>,
            },
            { label: 'Country Code', key: 'branchManagerPhoneCode', type: 'select', options: [], showSearch: true, onChange: v => this.props.form.setFieldsValue({ branchManagerPhoneCode: v }) },
            { label: "Phone", key: "branchManagerPhone" },
            { label: "Email", key: "branchManagerEmail" },

            {
              label: "Name",
              key: "branchHeadCounslerName",
              prefixComp: <h3>Sub Agent Counsellor</h3>,
            },
            { label: 'Country Code', key: 'branchHeadCounslerPhoneCode', type: 'select', options: [], showSearch: true, onChange: v => this.props.form.setFieldsValue({ branchHeadCounslerPhoneCode: v }) },
            { label: "Phone", key: "branchHeadCounslerPhone" },
            { label: "Email", key: "branchHeadCounslerEmail" },
            {
              label: "Invoice GST",
              key: "invoiceGST",
              type: "select",
              showSearch: true,
              allowClear: true,
              options: ['Include', 'Exclude'],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  invoiceGST: v,
                });
              },
            },
            {
              label: "Plan",
              key: "plan",
              type: "select",
              showSearch: true,
              allowClear: true,
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  plan: v,
                });
              },
            },
            {
              label: "Need Login Id",
              key: "loginId",
              type: "select",
              options: ["Yes", "No"],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  loginId: v,
                });
              },
            },
          ],
        },
        {
          tabTitle: "Payment Terms",
          opened: false,
          fields: [
            {
              label: "Commission",
              type: "number",
              key: "commission",
              rightComp: <span style={{ paddingLeft: "5px" }}>%</span>,
            },
            {
              label: "PAYMENT Terms",
              key: "paymentTerms",
              type: "textArea",
              rows: 5,
            },
            {
              label: "PAYMENT Guidelines Document",
              key: "paymentUpload",
              type: "file",
            },
            {
              label: "Bank Details 1",
              key: "bankDetails1",
              type: "textArea",
              rows: 5,
            },
            {
              label: "Bank Details 2",
              key: "bankDetails2",
              type: "textArea",
              rows: 5,
            },
            { label: 'Bank Name', key: 'bankName' },
            { label: 'Sub Agent Name & Address', key: 'branchNameAddress' },
            { label: 'Account No', key: 'accountNumber' },
            { label: 'Account Name', key: 'accountName' },
            { label: 'IFSC Code/Swift Code', key: 'ifsc' },
          ],
        },
      ],
    };

    this.loadCountries();
    this.getAgentTypePlans('Associate Partner');
  }

  setFormValues = async (branchId) => {
    try {
      let { doc } = await Request.getSubAgent(branchId);
      if (doc) {
        docLoaded = doc;
        this.loadStates(docLoaded.branchCountryId);
        this.loadCities(docLoaded.branchStateId);
        this.getAgentTypePlans();

        let tempObj = {};

        let inputTypes = this.state.inputTypes;

        _.each(inputTypes[0].fields, (v, k) => {
          tempObj[v.key] = docLoaded[v.key];
        });

        if (doc.isStateHead) {
          this.setState({ isStateHead: doc.isStateHead });
        }
        if (doc.branchIds) {
          this.setState({ branchIds: doc.branchIds });
        }
        if (doc.associatePartnerIds) {
          this.setState({ associatePartnerIds: doc.associatePartnerIds });
        }
        if (doc.branchAssociatePartner) {
          this.setState({ branchAssociatePartnerType: doc.branchAssociatePartner });
        }
        if (doc.showChannelPartner) {
          this.setState({ showChannelPartner: doc.showChannelPartner });
        }
        if (doc.showStaffToOtherBranch) {
          this.setState({ showStaffToOtherBranch: doc.showStaffToOtherBranch });
        }
        setTimeout(() => {
          this.props.form.setFieldsValue(tempObj);
        }, 1000);

      }
    } catch (e) {
      console.log(e);
    }
  };

  loadCountries = () => {
    let params = {
      results: 200,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        let phoneCodes = [];
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ _id: vv._id, display: vv.countryName });
          phoneCodes.push({ _id: vv.countryPhoneCode, display: vv.countryPhoneCode });
          return temp;
        }, []);
        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][2].options = resp.data;
        inputTypes[0]["fields"][8].options = phoneCodes;
        inputTypes[0]["fields"][12].options = phoneCodes;
        inputTypes[0]["fields"][16].options = phoneCodes;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  loadStates = (id) => {
    Request.loadStates(id)
      .then((daa) => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.stateName,
          });
          return total;
        }, []);

        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][3].options = daa.result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => { });
  };

  loadCities = (id) => {
    Request.loadCities(id)
      .then((daa) => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.cityName,
          });
          return total;
        }, []);
        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][4].options = daa.result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => { });
  };

  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild });
  };

  componentDidMount() {
    let searchParams = new URLSearchParams(this.props.search);
    branchId = searchParams.get("_id");
    if (branchId) {
      this.setState({ showFiles: 1 });
      this.setFormValues(branchId);
    }
  }

  render() {
    const {
      formOnly,
      form: { getFieldDecorator },
    } = this.props;

    // const submitFormLayout = {
    //   wrapperCol: {
    //     xs: { span: 24, offset: 0 },
    //     sm: { span: 10, offset: 7 },
    //     md: { span: 12, offset: 8 },
    //   },
    // };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
    };
    let { branchs, branchAssociatePartnerType } = this.state;
    let mainBranchs = branchs.filter((branch) => { return branch.branchAssociatePartner == 'Branch' });
    let associatePartners = branchs.filter((branch) => { return branch.branchAssociatePartner == 'Associate Partner' });
    let form = (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
        <Card bordered={true}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginBottom: 10 }}
            loading={this.props.loading}
          >
            SAVE
          </Button>
          <Tabs onChange={this.callback} type="card">
            {this.state.inputTypes.map((itype, key) => {
              return (
                <TabPane tab={itype.tabTitle} key={key + 1}>
                  <GetAllFormFields
                    apiurl={LAPI_URL}
                    inputSchema={this.state.inputTypes[key]}
                    refresh={this.refreshFxn}
                    getFieldDecorator={getFieldDecorator}
                  />
                  {key === 0 && this.state.isStateHead == true && (
                    <Form.Item label={"Sub Agents"} {...formItemLayout}>
                      <Select
                        allowClear
                        style={{ width: '550px' }}
                        showSearch={true}
                        mode="multiple"
                        value={this.state.branchIds}
                        placeholder="Select Option"
                        optionFilterProp="display"
                        filterOption={(input, option) => {
                          return (
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          )
                        }}
                        onChange={branchIds => {
                          this.setState(
                            {
                              branchIds
                            }
                          )
                        }}>
                        {mainBranchs.map((val, idn) => {
                          return (
                            <Option key={idn} value={val.id}>
                              {val.display}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  )}
                  {key === 0 && branchAssociatePartnerType == 'Branch' && (
                    <Form.Item label={"Associate Partners"} {...formItemLayout}>
                      <Select
                        allowClear
                        style={{ width: '550px' }}
                        showSearch={true}
                        mode="multiple"
                        value={this.state.associatePartnerIds}
                        placeholder="Select Option"
                        optionFilterProp="display"
                        filterOption={(input, option) => {
                          return (
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          )
                        }}
                        onChange={associatePartnerIds => {
                          this.setState(
                            {
                              associatePartnerIds
                            }
                          )
                        }}>
                        {associatePartners.map((val, idn) => {
                          return (
                            <Option key={idn} value={val.id}>
                              {val.display}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  )}
                </TabPane>
              );
            })}
          </Tabs>
        </Card>
      </Form>
    );

    return (
      <React.Fragment>
        {!formOnly ? (
          <PageHeaderWrapper title={"Add New Sub Agent"}>{form}</PageHeaderWrapper>
        ) : (
          form
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddSubAgent);
